import React, { useState } from "react";
import axios from "axios";
import { ApiEndpoints } from "../services/ApiConstants";

function Login({ onLoginSuccess }) {
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = () => {
        setLoading(true);
        setError("");
        axios.post(`${ApiEndpoints.BASE_URL}${ApiEndpoints.ADMIN_LOGIN}`, {
            userName: userName,
            password: password
        }).then((response) => {
            const data = response.data;
            if (data.loginStatus === true) {
                onLoginSuccess(data.token.tokenValue, data.adminDto.userName);
            } else {
                setError("Invalid username or password");
            }
            setLoading(false);
        }).catch((error) => {
            setError("Login failed. Please try again.");
            setLoading(false);
        });
    };

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            background: "var(--bg)"
        }}>
            <div style={{
                background: "var(--card)",
                border: "1px solid var(--border2)",
                padding: "40px",
                width: "360px",
                clipPath: "polygon(0 0,calc(100% - 12px) 0,100% 12px,100% 100%,12px 100%,0 calc(100% - 12px))"
            }}>
                <div className="logo-text" style={{ marginBottom: "30px", display: "inline-block" }}>METAGAIM</div>
                <div style={{ marginBottom: "20px" }}>
                    <div style={{ fontSize: "10px", fontWeight: "700", letterSpacing: "1px", color: "var(--text3)", textTransform: "uppercase", marginBottom: "6px" }}>Username</div>
                    <input
                        type="text"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        style={{
                            width: "100%",
                            background: "var(--bg3)",
                            border: "1px solid var(--border2)",
                            color: "var(--text)",
                            padding: "10px 14px",
                            fontSize: "14px",
                            outline: "none",
                            fontFamily: "var(--font-b)"
                        }}
                    />
                </div>
                <div style={{ marginBottom: "20px" }}>
                    <div style={{ fontSize: "10px", fontWeight: "700", letterSpacing: "1px", color: "var(--text3)", textTransform: "uppercase", marginBottom: "6px" }}>Password</div>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{
                            width: "100%",
                            background: "var(--bg3)",
                            border: "1px solid var(--border2)",
                            color: "var(--text)",
                            padding: "10px 14px",
                            fontSize: "14px",
                            outline: "none",
                            fontFamily: "var(--font-b)"
                        }}
                    />
                </div>
                {error && <div style={{ color: "var(--pink)", fontSize: "12px", marginBottom: "14px" }}>{error}</div>}
                <button
                    onClick={handleLogin}
                    disabled={loading}
                    style={{
                        width: "100%",
                        background: "rgba(128,246,255,0.08)",
                        border: "1px solid var(--neon)",
                        color: "var(--neon)",
                        padding: "12px",
                        fontSize: "12px",
                        fontWeight: "700",
                        letterSpacing: "2px",
                        textTransform: "uppercase",
                        cursor: "pointer",
                        fontFamily: "var(--font-b)"
                    }}
                >
                    {loading ? "LOGGING IN..." : "SIGN IN"}
                </button>
            </div>
        </div>
    );
}

export default Login;